<template>
  <div>
    <h4 class="content-block">Pegawai Add</h4>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabPanel"
          ref="myTabPanel"
          v-model:selected-index="tabPanelIndex"
          :data-source="tabData"
          :animation-enabled="true"
          item-title-template="title"
          item-template="currentTemplate"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #t2>
            <p>Isi form ini dengan data pekerjaan pegawai</p>
            <div class="editors">
              <div class="editors-container">
                <div class="left">
                  <DxSelectBox
                    :dataSource="jabatanSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Jabatan"
                    label="Jabatan"
                    v-model="job_histories.jabatan_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
                <div class="right">
                  <DxSelectBox
                    :dataSource="golonganSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Golongan"
                    label="Golongan"
                    v-model="job_histories.golongan_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
              </div>

              <div class="center">
                <DxSelectBox
                  :dataSource="cabangSource"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  placeholder="Cabang"
                  label="Cabang"
                  v-model="job_histories.cabang_id"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxSelectBox>
              </div>

              <div class="editors-container">
                <div class="left">
                  <DxSelectBox
                    :dataSource="bagianSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Bagian"
                    label="Bagian"
                    v-model="job_histories.bagian_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
                <div class="right">
                  <DxSelectBox
                    :dataSource="subBagianSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Sub bagian"
                    label="Sub bagian"
                    v-model="job_histories.sub_bagian_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
              </div>

              <div class="editors-container">
                <div class="left">
                  <DxDateBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    :display-format="'dd/MM/yyyy'"
                    :use-mask-behavior="true"
                    width="100%"
                    placeholder="Tgl mulai"
                    label="Tgl mulai"
                    v-model="job_histories.tgl_mulai"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxDateBox>
                </div>
                <div class="right">
                  <DxDateBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    :display-format="'dd/MM/yyyy'"
                    width="100%"
                    placeholder="Tgl akhir"
                    label="Tgl akhir"
                    v-model="job_histories.tgl_akhir"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxDateBox>
                </div>
              </div>

              <div class="center">
                <DxButton
                  @click="validateClick('t2', $event)"
                  text="Next"
                  type="default"
                  class="validate"
                />
              </div>
            </div>
          </template>

          <template #t4>
            <p>Isi form ini dengan data keluarga pegawai</p>
            <DxDataGrid
              id="dataGridKeluarga"
              :data-source="keluargaSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="rowInserting($event)"
              @row-inserted="rowInserted($event)"
              @saving="saving($event)"
              @saved="saved($event)"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxToolbar>
                <DxItem name="groupPanel" />
                <DxItem location="after" template="button-template" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #button-template>
                <DxButton
                  text="Import data"
                  :width="136"
                  @click="importClick"
                />
              </template>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                mode="row"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />

              <dx-column data-field="nama" caption="Nama">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column
                data-field="keluarga_hub_id"
                caption="Hubungan keluarga"
                sort-order="asc"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="keluargaHubSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="tempat_lahir" caption="Tempat lahir">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column
                data-field="tgl_lahir"
                caption="Tgl lahir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="nik" caption="NIK" data-type="number">
                <DxRequiredRuleDataGrid />
                <DxPatternRule
                  :pattern="patternNumeric"
                  message="NIK adalah angka!"
                />
              </dx-column>
              <dx-column
                data-field="perkawinan_status_id"
                caption="Status pernikahan"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="perkawinanStatusSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="jenis_kelamin" caption="Jenis kelamin">
                <DxLookup :data-source="jenisKelaminSource" />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column data-field="agama_id" caption="Agama">
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="agamaSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
            </DxDataGrid>
            <DxButton
              @click="validateClick('t4', $event)"
              text="SUBMIT"
              type="default"
              class="validate"
            />
          </template>

          <template #t3>
            <p>Isi form ini dengan data riwayat pendidikan pegawai</p>
            <DxDataGrid
              ref="dataGridRefKey"
              id="dataGridEdFormal"
              :data-source="pendidikanHistorySource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="rowInserting($event)"
              @row-inserted="rowInserted($event)"
              @saving="saving($event)"
              @saved="saved($event)"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxToolbar>
                <DxItem name="groupPanel" />
                <DxItem location="after" template="button-template" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #button-template>
                <DxButton
                  text="Import data"
                  :width="136"
                  @click="importClick"
                />
              </template>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                mode="row"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />

              <dx-column
                data-field="pendidikan_jenjang_id"
                caption="Jenjang"
                sort-order="asc"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="pendidikanJenjangSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="institusi" caption="Nama institusi">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column data-field="fakultas" caption="Fakultas">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column data-field="jurusan" caption="Jurusan">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column data-field="ipk" caption="IPK" data-type="number">
                <DxRequiredRuleDataGrid />
                <DxPatternRule
                  :pattern="patternNumeric"
                  message="IPK adalah angka!"
                />
              </dx-column>
              <dx-column data-field="tahun_mulai" caption="Tahun Mulai">
                <DxRequiredRuleDataGrid />
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column data-field="tahun_lulus" caption="Tahun Lulus">
                <DxRequiredRuleDataGrid />
                <DxRequiredRuleDataGrid />
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column data-field="ijazah_no" caption="Nomor Ijazah">
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <DxRequiredRuleDataGrid />
                <!-- <DxPatternRule
                  :pattern="patternDMY"
                  message="Format tgl dd-mm-yyyy!"
                /> -->

                <!-- <DxPatternRule
                  :pattern="pattern"
                  message='Your phone must have "(555) 555-5555" format!'
                /> -->
              </dx-column>

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :validationRules="[
                  {
                    type: 'pattern',
                    pattern:
                      /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
                    message: 'Tanggal must be in the format dd-mm-yyyy',
                  },
                ]"
              >
              </dx-column> -->

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :editor-options="editorOptions"
              >
              </dx-column> -->

              <dx-column data-field="ijazah_file" caption="File"></dx-column>
            </DxDataGrid>
            <DxButton
              @click="validateClick('t3', $event)"
              text="Next"
              type="default"
              class="validate"
            />
          </template>

          <template #t1>
            <p>Isi form ini dengan data personal pegawai</p>
            <div class="editors">
              <div class="editors-container">
                <div class="left">
                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Nama"
                    placeholder="Nama"
                    v-model="pegawais.nama"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>

                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Tempat lahir"
                    placeholder="Tempat lahir"
                    v-model="pegawais.tempat_lahir"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>

                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Telp"
                    placeholder="Telp"
                    v-model="pegawais.telp"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>
                </div>
                <div class="right">
                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Alamat"
                    placeholder="Alamat"
                    v-model="pegawais.alamat"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>
                  <DxDateBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    :display-format="'dd/MM/yyyy'"
                    width="100%"
                    placeholder="Tgl lahir"
                    label="Tgl lahir"
                    v-model="pegawais.tgl_lahir"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxDateBox>
                  <!-- <DxSelectBox
                    :items="states"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Select..."
                    label="Agama"
                  > -->
                  <DxSelectBox
                    :dataSource="agamaSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Agama"
                    label="Agama"
                    v-model="pegawais.agama_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
              </div>

              <!-- <div class="center">
                <DxTagBox
                  :items="positions"
                  :value="['Support Manager']"
                  :multiline="false"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  placeholder="Select..."
                  label="Position"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxTagBox>
              </div> -->
              <div class="center">
                <label for="fileUploader">Foto profil pegawai:</label>
                <DxFileUploader
                  ref="fileUploader"
                  accept="image/*"
                  upload-mode="useForm"
                  name="files"
                  multiple="false"
                  @value-changed="handleFileUploader($event, 'pegawai_foto')"
                >
                </DxFileUploader>
              </div>
              <div class="center">
                <DxButton
                  @click="validateClick('t1', $event)"
                  text="Next"
                  type="default"
                  class="validate"
                />
              </div>
            </div>
          </template>
        </DxTabPanel>

        <!-- <div class="options">
          <div class="caption">Options</div>
          <div class="option">
            <label>Styling Mode</label>
            <DxSelectBox
              :items="['outlined', 'filled', 'underlined']"
              v-model:value="stylingMode"
            />
          </div>
          <div class="option">
            <label>Label Mode</label>
            <DxSelectBox
              :items="['static', 'floating', 'hidden']"
              v-model:value="labelMode"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import axios from "axios";
// import DxTextArea from "devextreme-vue/text-area";
// import DxTagBox from "devextreme-vue/tag-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import ODataStore from "devextreme/data/odata/store";
import service from "./pegawai-add-data.js";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxToolbar,
  DxLookup,
  DxItem,
  DxPatternRule,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
import { DxFileUploader } from "devextreme-vue/file-uploader";

function formatDateISO(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("yyyy-MM-dd");
}
// const dataGridRefKey = "myDataGrid";
export default {
  components: {
    DxSelectBox,
    DxTextBox,
    // DxTextArea,
    // DxTagBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxEditing,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxLookup,
    DxItem,
    DxRequiredRule,
    DxRequiredRuleDataGrid,
    DxPatternRule,
    DxSorting,
    DxFileUploader,
  },
  data() {
    return {
      // dataGridRefKey,
      // pendidikanHistorySource: [
      //   {
      //     id: "",
      //     pendidikan_jenjang_id: "",
      //     institusi: "",
      //     fakultas: "",
      //     jurusan: "",
      //     ipk: "",
      //     tahun_mulai: "",
      //     tahun_lulus: "",
      //     ijazah_no: "",
      //     ijazah_tanggal: "",
      //     ijazah_file: "",
      //   },
      // ],
      // patternTglYMD: /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/,
      // patternTglYMD: /^\d{4}-\d{2}-\d{2}$/,
      // patternTglYMD: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, //INI YANG BENER YMD
      // patternTglYMD: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/, //INI YANG BENER DMY

      // patternTglYMD: /^\d{3}-\d{2}-\d{4}$/,
      patternDMY: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
      editorOptions: { mask: "99-99-9999", useMaskBehavior: true },
      pattern: /^\(\d{3}\) \d{3}-\d{4}$/i,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,
      keluargaSource: [
        {
          id: 1,
          nama: "anak pegawai",
          keluarga_hub_id: 4,
          tempat_lahir: "Denpasar",
          tgl_lahir: "12/02/2022",
          nik: 1111,
          perkawinan_status_id: 2,
          jenis_kelamin: "P",
          agama_id: 4,
        },
      ],
      pendidikanHistorySource: [
        {
          id: 1,
          pendidikan_jenjang_id: 1,
          institusi: "UNUD",
          fakultas: "TEKNIK",
          jurusan: "TI",
          ipk: 4,
          tahun_mulai: 1991,
          tahun_lulus: 1994,
          ijazah_no: "loremlorem",
          ijazah_tgl: "12/02/1992",
          ijazah_file: "loremlorem",
        },
      ],
      tabPanelIndex: 0,
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      pendidikanJenjangSource: new ODataStore({
        url: "http://127.0.0.1/odata/PendidikanJenjangs",
        key: "id",
      }),
      jenisKelaminSource: ["L", "P"],
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),

      tabData: [
        {
          text: "Personal data",
          template: "t1",
          disabled: false,
        },
        {
          text: "Employment data",
          template: "t2",
          disabled: true,
        },
        {
          text: "Riwayat Pendidikan data",
          template: "t3",
          disabled: true,
        },
        {
          text: "Keluarga data",
          template: "t4",
          disabled: true,
        },
      ],
      birthDate: new Date(1981, 5, 3),
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      text: "Olivia loves to sell. She has been selling DevAV products since 2012.",
      positions: service.getPositions(),
      states: service.getStates(),
      phoneRules: {
        X: /[02-9]/,
      },
      pegawais: {
        nama: "coba",
        alamat: "coba",
        telp: "coba",
        tempat_lahir: "coba",
        tgl_lahir: "01/12/2023",
        agama_id: 1,
      },
      job_histories: {
        jabatan_id: 3,
        cabang_id: 1,
        bagian_id: 2,
        sub_bagian_id: 4,
        golongan_id: 1,
        tgl_mulai: "01/01/2023",
        tgl_akhir: "01/12/2023",
      },
      pegawai_foto: null,
      pegawa_foto_non_binary: null,
    };
  },

  methods: {
    handleFileUploader(e, column) {
      console.log("================================");
      console.log(e);
      console.log(column);
      this.pegawai_foto = e.value[0];
      this.pegawa_foto_non_binary = e.value[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        this.imagePreviewUrl = reader.result;
      };
      reader.readAsDataURL(this.pegawai_foto);
    },
    rowInserting(e) {
      alert("insert row");
      console.log(e);
      console.log("inserting pendidikanhistories");
      console.log(this.pendidikanHistorySource);

      // e.cancel = true;
    },
    rowInserted(e) {
      console.log("ROW INSERTED");
      console.log(e);
      console.log(this.pendidikanHistorySource);
    },
    saving(e) {
      console.log("SAVING");
      console.log(e);
      console.log(this.pendidikanHistorySource);
    },
    saved(e) {
      console.log("SAVED");
      console.log(e);
      console.log(this.pendidikanHistorySource);
    },
    validateClick(tabSelected, e) {
      console.log("VALIDATECLICK 1");
      console.log(this.pendidikanHistorySource);
      console.log(this.pegawai_foto);
      const result = e.validationGroup.validate();
      if (result.isValid) {
        console.log("VALIDATECLICK 2");
        console.log(this.pendidikanHistorySource);
        notify("The task was saved successfully.", "success");
        //enable next step
        const nextTab = _.parseInt(_.nth(tabSelected, 1));
        this.tabPanelIndex = nextTab;
        // this.pegawais.tgl_lahir = formatDateISO(this.pegawais.tgl_lahir);
        console.log("nexttab " + nextTab);
        console.log(_.size(this.tabData));
        if (nextTab < _.size(this.tabData)) {
          this.tabData[nextTab]["disabled"] = false;
          console.log("MASIH ADA NEXT TAB");
        }

        console.log("nextTab" + nextTab);
        console.log("size " + _.size(this.tabData));
        if (nextTab == _.size(this.tabData)) {
          console.log("VALIDATECLICK 3");
          console.log(this.pendidikanHistorySource);
          //ini tab terakhir
          postDatabase(
            this.pegawais,
            this.job_histories,
            this.pendidikanHistorySource,
            this.keluargaSource,
            this.pegawai_foto,
            this.pegawa_foto_non_binary
          );
        }
        // this.$refs.myTabPanel.selectedIndex = nextTab;
      } else {
        console.log("VALIDATECLICK 4");
        console.log(this.pendidikanHistorySource);
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error"
        );
      }
    },
  },
};

function postDatabase(
  pegawais,
  job_histories,
  pendidikan_histories,
  keluargas,
  pegawai_foto,
  pegawai_foto_non_binary
) {
  console.log("POSTDATABASE ");
  console.log(pegawai_foto);
  console.log(pegawai_foto_non_binary);

  pegawais.tgl_lahir = formatDateISO(pegawais.tgl_lahir);
  job_histories.tgl_mulai = formatDateISO(job_histories.tgl_mulai);
  job_histories.tgl_akhir = formatDateISO(job_histories.tgl_akhir);

  // _.assign(
  //   pendidikan_histories,
  //   _.map(pendidikan_histories, (row) => {
  //     row.ijazah_tgl = formatDateISO(row.ijazah_tgl);
  //     console.log(row.ijazah_tgl);
  //     return row;
  //   })
  // );

  // const modified = formatDataISOFromArray(pendidikan_histories, "ijazah_tgl");

  _.forEach(pendidikan_histories, (item) => {
    item.ijazah_tgl = formatDateISO(item.ijazah_tgl);
  });

  _.forEach(keluargas, (item) => {
    item.tgl_lahir = formatDateISO(item.tgl_lahir);
  });

  console.log("MODIFIED");
  console.log(keluargas);
  const config = {
    headers: {
      // "content-type": "application/json",
      "content-type": "multipart/form-data",
    },
  };
  axios
    .post(
      "http://127.0.0.1/api/pegawai",
      {
        pegawais: pegawais,
        job_histories: job_histories,
        pendidikan_histories: pendidikan_histories,
        keluargas: keluargas,
        pegawai_foto: pegawai_foto_non_binary,
      },
      config
    )
    .then(function (res) {
      console.log(res);
      notify("Axios post success.", "success");
    })
    .catch(function (err) {
      console.log(err);
      notify("Axios post error.", "error");
    });
}
</script>
<style>
.title {
  padding: 20px 0 20px 0;
  font-size: 18px;
  font-weight: 500;
}

.editors {
  /* margin-right: 320px; */
  height: 570px;
  width: 100%;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
</style>
